<template>
  <Multiselect
    v-bind="reducedAttrs"
    :value="value"
    @input="(item) => $emit('input', item)"
    @search-change="(event) => $emit('search-change', event)"
    @select="$emit('select')"
    @remove="$emit('remove')"
  >
    <template
      v-if="isCustomCaretIcon"
      slot="caret"
    >
      <i
        :class="iconClass"
      />
    </template>
    <template slot="option" slot-scope="props">
        <span class="option__title text-wrap">{{ props.option.vendor_product }}</span>
    </template>
  </Multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'BaseMultiSelect',
  components: {
    Multiselect
  },
  props: {
    caretIconName: {
      type: String,
      default: null
    },
    // eslint-disable-next-line vue/require-prop-types
    value: {
      required: true
    }
  },
  computed: {
    reducedAttrs () {
      const attrs = Object.assign({}, this.$attrs)
      return attrs
    },
    isCustomCaretIcon () {
      return this.caretIconName !== null
    },
    iconClass () {
      return `fa fa-lg ${this.caretIconName} position-absolute custom-caret`
    }
  }
}
</script>

<style lang="sass" scoped >
.custom-caret
  right: 1px
  top: 8px
  padding: 4px 8px
</style>



// WEBPACK FOOTER //
// src/app/shared/components/BaseMultiselect.vue